import { render } from "./SideHeader.vue?vue&type=template&id=b2dbd3c0"
import script from "./SideHeader.vue?vue&type=script&lang=js"
export * from "./SideHeader.vue?vue&type=script&lang=js"

import "./SideHeader.vue?vue&type=style&index=0&id=b2dbd3c0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__